export enum EventType {
  CTA_CLICK = 'cta_click',
  MENU_CLICK = 'menu_click',
  SELECT_ITEM = 'select_item',
}
